module.exports = {
  missionStatement: "Help you build your physical, emotional and financial well-being through accessible, digital tools designed with a bias towards action."
}
